import logo from "client/wam/wam-client-logo.svg";
import svglogo from "client/wam/WamClientLogo";
import clientOnlyResources from ".";
import theme from "client/wam/theme";
import BusinessCenter from '@mui/icons-material/BusinessCenter'
import { 
  fullFeatureList,
  storeAttrOptions,
  storeGroupByOptions,
  itemAttrOptions,
  storeFilterOptions,
  itemGroupColumnOptions,
  runtimeItemGroupFilterOptions
} from 'client/wam/hardcoded_features'
// import DavFiles from "dav_files";
// import retry from 'custom_components/retry'


const appConfig = {
  CLIENT_NAME_LABEL: "Wam",
  CLIENT_NAME: "wam",
  CLIENT_LOGO: logo,
  APP_BAR_LOGO: svglogo,
  AUTH_SUPPLIER_SOURCES: [
    { id: "DST", name: "DST" }
  ],
  USER_ROLES: [
    { id: "wam", name: "Wam" },
    { id: "wam_admin", name: "Wam Admin" },
    { id: "site_admin", name: "Site Admin" },
    { id: "wam_onpoint_admin", name: "WAM OnPoint Admin" },
  ],
  CLIENT_CUSTOM_ROUTES: [
    // {
    //   path: "/files/wam_admin",
    //   component: DavFiles,
    //   allowedRoles: ["wam_admin", "site_admin"],
    // },
    // {
    //   path: "/files/wam",
    //   component: DavFiles,
    //   allowedRoles: ["wam", "wam_admin", "site_admin"],
    // },
  ],
  EXTRA_MENUS: {
    menuCustomer: [
     
      {
        to: `/wam_survey_summary`,
        label: "Survey Summary",
        icon: <BusinessCenter />,
        // featureTag: "director",
      },
      // {
      //   to: `/wam_regional`,
      //   label: "Regional",
      //   icon: <TeamIcon />,
      //   featureTag: "regional",
      // },
      // {
      //   to: `/wam_broker`,
      //   label: "Broker",
      //   icon: <ContactsIcon />,
      //   featureTag: "broker",
      // },
    ],
    menuItem: [
      // {
      //   to: `/wam_product_hierarchy`,
      //   label: "Product Hierarchy",
      //   icon: <ProductCategoryIcon />,
      //   featureTag: "product_hierarchy",
      // },
    ],
    // menuFiles: [
    //   // {
    //   //   // side menu link for Wam Admin File access
    //   //   to: "/files/wam_admin",
    //   //   label: "Admin Files",
    //   //   icon: <FolderSpecialIcons />,
    //   //   allowedRoles: ["wam_admin", "site_admin"],
    //   // },
    //   // {
    //   //   // side menu link for Wam File Access
    //   //   to: `/files/wam`,
    //   //   label: "Files",
    //   //   icon: <FolderSharedIcon />,
    //   //   allowedRoles: ["wam", "wam_admin", "site_admin"],
    //   // },
    // ],
    // 'extraMenu': {}
  },
  CUSTOM_PAGES: {
    master_chain: {
      list: null,
      edit: null
      // edit: React.lazy(() =>
      //   retry(() => import("./master_chain/MasterChainEdit"))
      // ),
      // list: null,
    },
    master_distributor: {
      list: null,
      edit: null
      // edit: React.lazy(() =>
      //   retry(() => import("./master_distributor/MasterDistributorEdit"))
      // ),
      // list: null,
    },
    master_customers: {
      list: null,
      edit: null
      // edit: React.lazy(() => retry(() => import("./master_customers/Edit"))),
      // list: React.lazy(() => retry(() => import("./master_customers/List"))),
    },
    master_items: {
      list: null,
      edit: null
      // edit: React.lazy(() => retry(() => import("./master_items/Edit"))),
      // list: React.lazy(() => retry(() => import("./master_items/List"))),
    },
  },
  DASHBOARD_CONFIG: {
    dimensions: {},
    sunburstHierarchies: {
      "Distributor/Warehouse": ["distributor_name", "warehouse_name"],
      "Product Hierarchy": [
        "product_hierarchy_level_1"
      ],
    },
  },
  DEPLOY_TARGET_TABS: [
    { id: "main_dashboard", name: "Main Dashboard" }, // default - main dashboard
    { id: "brand_id", name: "Items" }, // default - item level page
    {
      id: "distributor",
      name: "Distributors",
      dimension: "distributor_name",
      targetConfig: {
        resource_name: "wam_distributor",
        name: "Distributor",
        column_defs: [{ id: 50 }, { name: 350 }],
        filter_column: "warehouse_name@eq",
      },
    }, // default - chain page
    {
      id: "master_chain",
      name: "Chains",
      dimension: "wam_chain",
      targetConfig: {
        resource_name: "master_chain",
        name: "Chain",
        column_defs: [{ id: 50 }, { primary_name: 350 }],
        filter_column: "wam_chain@eq",
      },
    }, // default - chain page
    
  ],
  CUSTOM_RESOURCES: clientOnlyResources,
  CLIENT_THEME: theme,
  BACKGROUND_IMAGE: "bg.jpg",
  featureList: fullFeatureList,
  routeOverrides: {},
  REPORTING_OPTIONS: {
    storeAttrOptions,
    storeGroupByOptions,
    itemAttrOptions,
    storeFilterOptions,
    itemGroupColumnOptions,
    runtimeItemGroupFilterOptions,
    reportAvailability: {
      "Period Comparison": true,
      "Period Comparison Store Level": true,
      "Fact Summary": true,
      "Store Rows/Item Columns Pivot": true,
      "Store Group Rows/Item Columns Pivot": true,
      "Store Rows/Item Columns Pivot (No Item Groups)": true,
      "Item Group Summary": true,
      "ACV by Store Group And Period": true,
    },
    calendarFormat: "445"
  }
};

export default appConfig;
